// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelsPage-ModalWrapper_cls1__scOaq","cls2":"PaymentChannelsPage-ModalWrapper_cls2__dSnnC PaymentChannelsPage-ModalWrapper_cls1__scOaq"};